import { render, staticRenderFns } from "./EditCollege.vue?vue&type=template&id=34b6540a&"
import script from "./EditCollege.vue?vue&type=script&lang=js&"
export * from "./EditCollege.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports